var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmericanFlag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Flags",
    clipPath: "url(#clip0_3427_18951)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11 0.375H2C1.17157 0.375 0.5 1.04657 0.5 1.875V10.875C0.5 11.7034 1.17157 12.375 2 12.375H11C11.8284 12.375 12.5 11.7034 12.5 10.875V1.875C12.5 1.04657 11.8284 0.375 11 0.375Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3427_18951",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11 0.375H2C1.17157 0.375 0.5 1.04657 0.5 1.875V10.875C0.5 11.7034 1.17157 12.375 2 12.375H11C11.8284 12.375 12.5 11.7034 12.5 10.875V1.875C12.5 1.04657 11.8284 0.375 11 0.375Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3427_18951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 0.375H0.5V1.175H12.5V0.375ZM12.5 1.97498H0.5V2.77498H12.5V1.97498ZM0.5 3.57495H12.5V4.37495H0.5V3.57495ZM12.5 5.17511H0.5V5.97511H12.5V5.17511ZM0.5 6.7749H12.5V7.5749H0.5V6.7749ZM12.5 8.37506H0.5V9.17506H12.5V8.37506ZM0.5 9.97504H12.5V10.775H0.5V9.97504ZM12.5 11.5748H0.5V12.3748H12.5V11.5748Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.64286 0.375H0.5V5.975H5.64286V0.375Z",
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter0_d_3427_18951)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7853 1.57529C2.7853 1.79621 2.65738 1.97529 2.49958 1.97529C2.34179 1.97529 2.21387 1.79621 2.21387 1.57529C2.21387 1.35438 2.34179 1.17529 2.49958 1.17529C2.65738 1.17529 2.7853 1.35438 2.7853 1.57529ZM1.64272 1.57542C1.64272 1.79633 1.5148 1.97542 1.357 1.97542C1.19921 1.97542 1.07129 1.79633 1.07129 1.57542C1.07129 1.3545 1.19921 1.17542 1.357 1.17542C1.5148 1.17542 1.64272 1.3545 1.64272 1.57542ZM3.64289 1.97529C3.80069 1.97529 3.92861 1.79621 3.92861 1.57529C3.92861 1.35438 3.80069 1.17529 3.64289 1.17529C3.4851 1.17529 3.35718 1.35438 3.35718 1.57529C3.35718 1.79621 3.4851 1.97529 3.64289 1.97529ZM5.07118 1.57529C5.07118 1.79621 4.94327 1.97529 4.78547 1.97529C4.62767 1.97529 4.49976 1.79621 4.49976 1.57529C4.49976 1.35438 4.62767 1.17529 4.78547 1.17529C4.94327 1.17529 5.07118 1.35438 5.07118 1.57529ZM1.92829 2.77546C2.08609 2.77546 2.21401 2.59638 2.21401 2.37546C2.21401 2.15455 2.08609 1.97546 1.92829 1.97546C1.7705 1.97546 1.64258 2.15455 1.64258 2.37546C1.64258 2.59638 1.7705 2.77546 1.92829 2.77546ZM3.35732 2.37528C3.35732 2.59619 3.2294 2.77528 3.0716 2.77528C2.91381 2.77528 2.78589 2.59619 2.78589 2.37528C2.78589 2.15437 2.91381 1.97528 3.0716 1.97528C3.2294 1.97528 3.35732 2.15437 3.35732 2.37528ZM4.21418 2.77546C4.37198 2.77546 4.4999 2.59638 4.4999 2.37546C4.4999 2.15455 4.37198 1.97546 4.21418 1.97546C4.05639 1.97546 3.92847 2.15455 3.92847 2.37546C3.92847 2.59638 4.05639 2.77546 4.21418 2.77546ZM5.07118 3.17527C5.07118 3.39618 4.94327 3.57527 4.78547 3.57527C4.62767 3.57527 4.49976 3.39618 4.49976 3.17527C4.49976 2.95435 4.62767 2.77527 4.78547 2.77527C4.94327 2.77527 5.07118 2.95435 5.07118 3.17527ZM3.64289 3.57527C3.80069 3.57527 3.92861 3.39618 3.92861 3.17527C3.92861 2.95435 3.80069 2.77527 3.64289 2.77527C3.4851 2.77527 3.35718 2.95435 3.35718 3.17527C3.35718 3.39618 3.4851 3.57527 3.64289 3.57527ZM2.7853 3.17509C2.7853 3.396 2.65738 3.57509 2.49958 3.57509C2.34179 3.57509 2.21387 3.396 2.21387 3.17509C2.21387 2.95417 2.34179 2.77509 2.49958 2.77509C2.65738 2.77509 2.7853 2.95417 2.7853 3.17509ZM1.357 3.57527C1.5148 3.57527 1.64272 3.39618 1.64272 3.17527C1.64272 2.95435 1.5148 2.77527 1.357 2.77527C1.19921 2.77527 1.07129 2.95435 1.07129 3.17527C1.07129 3.39618 1.19921 3.57527 1.357 3.57527ZM2.21401 3.97526C2.21401 4.19617 2.08609 4.37526 1.92829 4.37526C1.7705 4.37526 1.64258 4.19617 1.64258 3.97526C1.64258 3.75434 1.7705 3.57526 1.92829 3.57526C2.08609 3.57526 2.21401 3.75434 2.21401 3.97526ZM3.0716 4.37526C3.2294 4.37526 3.35732 4.19617 3.35732 3.97526C3.35732 3.75434 3.2294 3.57526 3.0716 3.57526C2.91381 3.57526 2.78589 3.75434 2.78589 3.97526C2.78589 4.19617 2.91381 4.37526 3.0716 4.37526ZM4.4999 3.97526C4.4999 4.19617 4.37198 4.37526 4.21418 4.37526C4.05639 4.37526 3.92847 4.19617 3.92847 3.97526C3.92847 3.75434 4.05639 3.57526 4.21418 3.57526C4.37198 3.57526 4.4999 3.75434 4.4999 3.97526ZM4.78547 5.17524C4.94327 5.17524 5.07118 4.99616 5.07118 4.77524C5.07118 4.55433 4.94327 4.37524 4.78547 4.37524C4.62767 4.37524 4.49976 4.55433 4.49976 4.77524C4.49976 4.99616 4.62767 5.17524 4.78547 5.17524ZM3.92861 4.77524C3.92861 4.99616 3.80069 5.17524 3.64289 5.17524C3.4851 5.17524 3.35718 4.99616 3.35718 4.77524C3.35718 4.55433 3.4851 4.37524 3.64289 4.37524C3.80069 4.37524 3.92861 4.55433 3.92861 4.77524ZM2.49958 5.17524C2.65738 5.17524 2.7853 4.99616 2.7853 4.77524C2.7853 4.55433 2.65738 4.37524 2.49958 4.37524C2.34179 4.37524 2.21387 4.55433 2.21387 4.77524C2.21387 4.99616 2.34179 5.17524 2.49958 5.17524ZM1.64272 4.77524C1.64272 4.99616 1.5148 5.17524 1.357 5.17524C1.19921 5.17524 1.07129 4.99616 1.07129 4.77524C1.07129 4.55433 1.19921 4.37524 1.357 4.37524C1.5148 4.37524 1.64272 4.55433 1.64272 4.77524Z",
    fill: "url(#paint0_linear_3427_18951)"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3427_18951",
    x: 1.07129,
    y: 1.17529,
    width: 4,
    height: 4.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3427_18951"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3427_18951",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3427_18951",
    x1: 1.07129,
    y1: 1.17529,
    x2: 1.07129,
    y2: 5.17528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3427_18951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 13,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmericanFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/AmericanFlag.29e3574d5fae709cfe0653568bb9bf00.svg";